import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { isRenault, GA_ID } from '../util/constants';
// Redux Actions
import { showError } from './../redux/snackbar'
import { nextStep } from './../redux/step'
import { setCustomer } from './../redux/customer'
import { setVehicles } from './../redux/vehicles'
import { setCustomerInfo, updateForm, setDealer } from './../redux/form'
import { setVehicleInfo } from './../redux/form'
import { setFormerDealer } from './../redux/formerDealer'
import { setPortLogin } from './../redux/portLogin'
import { setLoading } from './../redux/loading'
import { setVehicleModel as setVehicleModelRedux } from './../redux/form'
import { setUtmValues } from './../redux/utmValues'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'

// Custom
import PhoneInput from './../components/PhoneInput'
import CustomTextField from './../components/CustomTextField'
import CustomCard from "../components/CustomCard";
import CustomLabel from '../components/CustomFormLabel';

// Api Requests
import { sendVerificationCode, getVerificationCode, getFormerDealer, getCustomer } from './../services/index'
import { formatPhone } from '../util/helper';

// Styles
const styles = {
    formRoot: {
        width: '100%'
    },
}

// Spacing
// const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }


function Form0(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const loading = useSelector(state => state.loading)

    const { chassisNo } = useParams();

    // Media query screen size
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        // const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }
        // const spacings = { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }
        const spacings = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // 0 initial, 1 sms verifiation
    const [portLoginState, setPortLoginState] = useState(0);


    // On mount
    useEffect(() => {
        // Get Utm Values From Query
        const queryParams = new URLSearchParams(window.location.search);
        const utmCampaign = queryParams.get('utm_campaign');
        const utmMedium = queryParams.get('utm_medium');
        const utmSource = queryParams.get('utm_source');
        const origin = queryParams.get('ORIGIN');
        const campaign = queryParams.get('CAMPAIGN');
        const platform = queryParams.get('platform');

        dispatch(setUtmValues({ utmCampaign: utmCampaign, utmMedium: utmMedium, utmSource: utmSource, origin: origin, campaign: campaign, platform: platform }))

    }, [])

    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'brand': isRenault ? 'renault' : 'dacia',
            'googleAccount': GA_ID,
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'languageCode': 'tr',
            'countryCode': 'TR',
            'vehicleModel': '',
            'vehicleId': '',
            'dealerName': '',
            'dealerId': '',
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formOpen',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'start',
            'formStepNumber': 'step-0',
            'vehicleModel': '',
            'vehicleId': '',
            'dealerName': '',
            'dealerId': ''
        });




    }, [])


    //Gets fields from params to fill the form
    const { search } = useLocation()
    const searchParams = new URLSearchParams(search)
    const phoneFromParam = searchParams.get('phone')
    const chassisOrPlateFromParam = searchParams.get('chassisOrPlate')
    const nameFromParam = searchParams.get('name')
    const surnameFromParam = searchParams.get('surname')
    const emailFromParam = searchParams.get('email')
    const kmFromParam = searchParams.get('km')

    // On mount
    useEffect(() => {
        if (phoneFromParam || chassisOrPlateFromParam || nameFromParam || surnameFromParam || emailFromParam || kmFromParam) {
            setPhone(phoneFromParam ? ('90' + phoneFromParam?.slice(-10)) : '')
            setChassisOrPlate(chassisOrPlateFromParam ? chassisOrPlateFromParam?.slice(0, 17) : '')
            // Add customer info form
            dispatch(updateForm({
                name: nameFromParam || '',
                surname: surnameFromParam || '',
                email: emailFromParam || '',
                phone: phoneFromParam ? formatPhone(('90' + phoneFromParam?.match(/\d/g).join("").slice(-10)), '(##) ### ### ## ##') : '',
                km: kmFromParam ? kmFromParam?.match(/\d/g).join("") : '',
            }))
        }
    }, [phoneFromParam, chassisOrPlateFromParam, nameFromParam, surnameFromParam, emailFromParam, kmFromParam,])


    // Forms
    const [chassisOrPlate, setChassisOrPlate] = useState(chassisNo ? chassisNo : '');
    const [phone, setPhone] = useState('');
    const [smsCode, setSmsCode] = useState('');
    const [phoneVerificationId, setPhoneVerificationId] = useState('');

    // Form errors
    const [smsCodeError, setSmsCodeError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [chassisOrPlateError, setChassisOrPlateError] = useState(false);

    const [carPlateButton, setCarPlateButtonColor] = useState('inherit')
    const [phoneButton, setPhoneButtonColor] = useState('inherit')

    // Login from port
    function handlePortLogin() {

        // Form validation
        let error = false;
        if (!phone || !phone.match(/(\()*[0-9]{2}(\))*\s*[0-9]{3}\s*[0-9]{3}\s*[0-9]{2}\s*[0-9]{2}/g)) {
            error = true
            setPhoneError(true)
        }

        // Don't proceed if there is an error 
        if (!error) {

            // Set loading
            dispatch(setLoading(true))
            // Send sms to customer
            getVerificationCode(phone.replace(/[^0-9]/g, ''))
                .then(phoneVerificationId => {
                    setPhoneVerificationId(phoneVerificationId)
                    setPortLoginState(1)
                })
                .catch(e => {
                    console.error(e)
                    dispatch(showError(t('UNKNOWN_ERROR')))
                })
                .finally(() => {
                    dispatch(setLoading(false))
                })
        }
    }

    // Login from port
    function handleSmsVerify() {
        if (loading) { return }

        // Form validation
        let error = false;
        if (!smsCode || !smsCode.match(/[0-9]\s*[0-9]\s*[0-9]\s*[0-9]/g)) {
            error = true
            setSmsCodeError(true)
        }

        // Don't proceed if there is an error 
        if (!error) {

            // Set loading
            dispatch(setLoading(true))

            const body = {
                phoneVerificationId,
                code: smsCode.replace(/\s/g, ''),
            }

            // Get customer info
            sendVerificationCode(body)
                .then(isAlreadyUser => {
                    if (!isAlreadyUser) {
                        dispatch(showError('Porta kayıtlı değilsiniz'))
                    }
                    else {

                        getCustomer()
                            .then(customer => {

                                // Save data
                                dispatch(setCustomer(customer))
                                dispatch(setVehicles(customer.vehicles))

                                // Set dealer if last visited dealer
                                if (customer.formerDealer) {
                                    dispatch(setFormerDealer(customer.formerDealer))
                                    //dispatch(setDealer(customer.formerDealer)) //Dealer idleri farklı olduğu için getTimeSlots boş veri dönüyor
                                }

                                // Add customer info form
                                dispatch(setCustomerInfo({
                                    phone: customer.phone || '',
                                    name: customer.name || '',
                                    surname: customer.surname || '',
                                    email: customer.email || '',
                                }))

                                // Sms verificaton state
                                setPortLoginState(0)

                                // Set login type
                                dispatch(setPortLogin(true))

                                // Next step
                                dispatch(nextStep())

                            })
                            .catch(e => {
                                dispatch(showError(t('UNKNOWN_ERROR')))
                            })
                    }
                })
                .catch(e => {
                    if (e instanceof Error) {
                        console.error(e)
                        dispatch(showError(t('UNKNOWN_ERROR')))
                    }
                    else {
                        dispatch(showError('Girdiğiniz Kod Hatalı'))
                    }
                })
                .finally(() => {
                    dispatch(setLoading(false))
                })
        }
    }

    // Login with palte or chassis
    function handlePlateChassisLogin() {
        if (loading) { return }

        // Form validation
        let error = false;
        if (chassisOrPlate.replaceAll(" ", "").length === 0 || chassisOrPlate.length < 5) {
            error = true
            setChassisOrPlateError(true)
        }

        // Don't proceed if there is an error
        if (!error) {

            // Set loading
            dispatch(setLoading(true))

            // Set Chassis error false 
            setChassisOrPlateError(false)

            // Get customer info
            getFormerDealer(chassisOrPlate.replaceAll(" ", ""))
                .then(({ dealer: formerDealer, isSuccess: _isSuccess, vehicleModel: _vehicleModel }) => {

                    // Set vehicle info
                    dispatch(setVehicleInfo(chassisOrPlate.replaceAll(" ", "")))

                    // Set login type
                    dispatch(setPortLogin(false))

                    // Set last visited dealer if exist
                    if (formerDealer) dispatch(setFormerDealer(formerDealer))

                    if (_isSuccess) {

                        // Save vehicle model
                        dispatch(setVehicleModelRedux(_vehicleModel))

                        // Next step
                        dispatch(nextStep())
                    }
                    else {

                        // Next step
                        dispatch(nextStep())
                    }
                }).catch(e => {
                    dispatch(showError(t('UNKNOWN_ERROR')))
                })
                .finally(() => {
                    dispatch(setLoading(false))
                })


        }
    }

    function changeColorPlateButton(event) {
        if (event.target.value.length >= 5) {
            setCarPlateButtonColor('secondary');
        } else {
            setChassisOrPlateError(true);
            setCarPlateButtonColor('inherit');
        }
    }

    function changeColorPhoneButton(event) {

        if (!event.target.value.match(/(\()*[0-9]{2}(\))*\s*[0-9]{3}\s*[0-9]{3}\s*[0-9]{2}\s*[0-9]{2}/g)) {
            setPhoneButtonColor('inherit');
        } else {
            setPhoneButtonColor('secondary');
        }
    }

    function formatChassisPlate(text) {
        let firstChar = isNaN(text.charAt(0))
        if (firstChar) {
            setChassisOrPlate(text)
            return
        };
        text = text.replaceAll(" ", "")
        var tmp = "";
        var numStr = !isNaN(text.charAt(0));
        for (var i = 0; i < text.length; i++) {
            if (!isNaN(text.charAt(i)) !== numStr) {
                tmp += " ";
                numStr = !isNaN(text.charAt(i));
            }
            tmp += text.charAt(i);
        }
        setChassisOrPlate(tmp);
        return

    }

    function getCardContent() {
        return (
            <Grid container spacing={spacingForm} style={{ overflow: 'inherit', minHeight: xsDown ? undefined : "350px" }}>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant='h4' color='textPrimary' align='center'>
                        {t('appointmentMethod')}
                    </Typography>
                </Grid>
                {/* Take Appoinment Form */}
                <Grid item xs={12}>
                    <form style={styles.formRoot} noValidate autoComplete="off" onSubmit={e => { e.preventDefault(); handlePlateChassisLogin() }}>
                        <Grid container spacing={spacingForm} >

                            {/* Title */}
                            <Grid item xs={12}>
                                <Typography variant='h6' color='textPrimary'>
                                    {t('takeAppointment')}
                                </Typography>
                                <Typography variant='subtitle1' style={{ color: 'gray', fontSize: '1em' }}>
                                    {t('takeAppointmentExplain')}
                                </Typography>
                            </Grid>

                            {/* Plate or Chassis */}
                            <Grid item xs={12}>
                                <CustomLabel content={t('plateChassisInput')} />
                                <CustomTextField
                                    fullWidth
                                    variant='outlined'
                                    value={chassisOrPlate}
                                    onChange={e => {
                                        changeColorPlateButton(e);
                                        if (e.target.value.length < 5 && e.target.value.length > 0) {
                                            setChassisOrPlateError(true);
                                        } else if (e.target.value.length > 17) {
                                            setChassisOrPlateError(true);
                                            formatChassisPlate(chassisOrPlate)
                                            return
                                        } else {
                                            setChassisOrPlateError(false);
                                        }
                                        formatChassisPlate(e.target.value.toUpperCase());
                                    }}
                                    error={chassisOrPlateError}
                                    errorText={(chassisOrPlate.length === 17 && chassisOrPlateError) ? t("chassisInputError") : t("plateChassisInputError")}
                                />

                            </Grid>

                            {/* Button */}
                            <Grid item xs={12} container justifyContent='flex-end'>
                                <Button variant="contained" color={carPlateButton} style={{ width: '210px', minHeight: '42px' }} disableElevation type='submit'>
                                    {t('startBtn')}
                                </Button>
                            </Grid>

                        </Grid>
                    </form>
                </Grid>

                {/* Divider */}
                <Grid item xs={12} sm={12} md={12} style={{ padding: "8px" }}>
                    <Typography
                        color="textSecondary"
                        display="block"
                        //variant="caption"
                        variant='h5'
                        align='center'
                    >
                        veya
                    </Typography>
                </Grid>
                {/* Login Port Form */}
                <Grid item xs={12}>
                    <form style={styles.formRoot} noValidate autoComplete="off" onSubmit={e => { e.preventDefault(); portLoginState === 0 ? handlePortLogin() : handleSmsVerify() }}>
                        <Grid container spacing={spacingForm}>

                            {/* Phone State */}
                            {
                                portLoginState === 0 &&
                                <>
                                    {/* Title */}
                                    <Grid item xs={12}>
                                        <Typography variant='h6' color='textPrimary'>
                                            {t('loginWithPort')}
                                        </Typography>
                                        <Typography variant='subtitle1' style={{ color: 'gray', fontSize: '1em' }}>
                                            {t('loginWithPortExplain')}
                                        </Typography>
                                    </Grid>

                                    {/* Phone */}
                                    <Grid item xs={12}>
                                        <CustomLabel content={t('phone')} />
                                        <PhoneInput
                                            state={phoneError ? 'error' : ''}
                                            error={phoneError}
                                            helperText={phoneError ? t('phoneError') : null}
                                            fullWidth
                                            variant='outlined'
                                            value={phone}
                                            onChange={e => {
                                                setPhone(e.target.value);
                                                changeColorPhoneButton(e);
                                                if (e.target.value) setPhoneError(false)
                                            }}
                                            mask='(\90) 599 999 99 99'
                                        />
                                    </Grid>

                                    {/* Button */}
                                    <Grid item xs={12} container justifyContent='flex-end'>
                                        <Button variant="contained" color={phoneButton} style={{ width: '210px', minHeight: '42px' }} disableElevation type='submit'>
                                            {t('startBtn')}
                                        </Button>
                                    </Grid>

                                </>
                            }

                            {/* Sms State */}
                            {
                                portLoginState === 1 &&
                                <>
                                    {/* Title */}
                                    <Grid item xs={12}>
                                        <Typography variant='h7' color='textPrimary'>
                                            {t('smsCode')}
                                        </Typography>
                                    </Grid>

                                    {/* Sms */}
                                    <Grid item xs={12}>
                                        <PhoneInput
                                            state={smsCodeError ? 'error' : ''}
                                            error={smsCodeError}
                                            helperText={smsCodeError ? t('smsCodeError') : null}
                                            fullWidth
                                            center
                                            placeholder='X X X X'
                                            variant='outlined'
                                            value={smsCode}
                                            onChange={e => {
                                                setSmsCode(e.target.value);
                                                if (e.target.value) setSmsCodeError(false)
                                            }}
                                            mask='9 9 9 9'
                                        />
                                    </Grid>

                                    {/* Button */}
                                    <Grid item xs={12} container justifyContent='space-between'>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            onClick={() => setPortLoginState(0)}
                                            style={{ minWidth: '105px' }}
                                        >
                                            {t('backButtonSms')}
                                        </Button>

                                        <Button variant="contained" color="primary" style={{ minWidth: '105px' }} disableElevation type='submit'>
                                            {t('verifyButtonSms')}
                                        </Button>
                                    </Grid>
                                </>
                            }

                        </Grid>
                    </form>
                </Grid>

            </Grid>
        );
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={getCardContent()}
        />
    )
}

// Connect redux and translation
export default Form0